import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './FAQPage.css'
import { Link } from 'react-router-dom';

function InfoElement() {
   return (
      <div className='acordion_wrapper'>
         <Accordion className='acordion' defaultExpanded={true} disabled={true}>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography >Мета та ціль проєкту <br /> (Солов'їна мова)</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography >
                  Мета цього проєкту полягає: <br />
                  1. Збір матеріальної допомоги для Збройних Сил України та/або дитячих будинків; <br />
                  2. Допомога молодим розробникам у цей складний час, шляхом реклами та фінансового заохочення для участі у проєкті. Наша мета - створити платформу де молоді, талановиті та амбітні розробники зможуть ділитися знаннями, навичками та досвідом з іншими учасниками проєкту та всіми бажаючими. <br />
                  3. Поєднання приємного з корисним. Ми розуміємо, що розробка програмного забезпечення та IT-індустрія загалом можуть бути виснажливими, тому ми прагнемо додавати розважальний контент, який зробить цей світ цікавішим. Ми вважаємо, що поєднання розважального та корисного контенту допоможе залучити більше учасників до проєкту та зробить його більш привабливим для широкої аудиторії.
               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel1a-content"
               id="panel1a-header"
            >
               <Typography>
                  Загальна інформація про івент
               </Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>
                  У івенті беруть участь IT розробники та представляють свої pet project. 
                  <br />
                  <br />
                  Кожен івент триває близько 5-6 днів, що можна детальніше перевірити на табло зворотного відліку на <Link style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} to='/info' target={"_blank"}>сторінці</Link> з проєктами учасників.
                  <br />
                  <br />
                  По закінченню івента буде визначено трьох переможців за допомогою голосів усіх не байдужих.
                  <br />
                  <br />
                  Голосування відбувається в <a target={"_blank"} style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} href="https://t.me/the_way_of_junior">телеграм-каналі</a> , на який можна перейти за посиланням на головній сторінці або безпосередньо з будь-якого блоку учасника.
                  <br />
                  <br />
                  Благодійні кошти на підтримку ЗСУ та/або дитячого будинку, а також для заохочення учасників можна перевести за <a target={"_blank"} style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} href="https://send.monobank.ua/jar/5rJky3qhy9">посиланням</a> на головній сторінці або безпосередньо з будь-якого блоку учасника. Всі зібрані кошти будуть передані на підтримку обраних благодійних організацій та заохочення переможців івенту.
                  <br />
                  <br />
                  Кожен івент це окреме голосування та окремий збір коштів.
                  <br />
                  <br />
                  Після кожного івенту буде визначено переможців і передано гроші до визначеного благодійного фонду.
               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography>Правила участі</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>

                  Участь можуть приймати розробники, які відповідають наступним категоріям: <br />
                  1. Frontend розробник; <br />
                  2. Не має комерційного досвіду (взагалі); <br />
                  3. Має pet project, яким він бажає поділитися зі світом: <br />
                  - pet project створений самостійно; <br />
                  - pet project вивантажений у GIT; <br />
                  - pet project має посилання на робочу версію; <br />
                  4. Готовий зробити символічний внесок у призовий фонд; <br />
                  5. Учасник має надати інформацію (ім'я, прізвище, скріншот проєкту, посилання на Linkedin, робоче посилання на проєкт, посилання на GIT де розміщений проєкт). <br />
                  6.Організатори івенту залишають за собою право відхилити будь-яку заявку. <br />

               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography>Призовий фонд</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>
               По закінченню івента, благодійний фонд буде розподілений наступним чином: <br />
               - 50% зібраних коштів будуть передані в фонд, який був обраний організаторами, для підтримки Збройних Сил України або дитячого будинку; <br />
               - решта коштів буде розділена між трьома переможцями згідно з їхнім місцем у змаганні.  Переможець, який здобув перше місце, отримає 50% від решти зібраних коштів, а переможці, які зайняли друге і третє місце, отримають по 25% кожен.
               </Typography>
            </AccordionDetails>
         </Accordion>
      </div>
   );
}

export default InfoElement;